import { readable } from 'svelte/store';

export const currentTime = readable(new Date(), function start(set) {
  const interval = setInterval(() => {
    set(new Date());
  }, 1000);

  return function stop() {
    clearInterval(interval);
  };
});

export function getDateString(date: Date) {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() + offset * 60 * 1000);
  return date.toISOString().split('T')[0];
}

export function formatRaceStartTimeWithDay(time: Date | undefined | null) {
  if (!time) return null;

  // check if time is string
  if (typeof time === 'string') {
    time = new Date(time);
  }

  return (
    formatTime(time) +
    ' ' +
    time.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })
  );
}

export function calculateTimeToJump(
  time: Date | undefined | null,
  now: Date,
  onlyLargest = false
): string | null {
  // Output a time difference in a human readable format
  if (!time) return null;
  const timestamp = time.getTime();
  const nowTs = now.getTime();
  // const time = new Date(timestamp * 1000);
  const diff = timestamp - nowTs;
  const sign = diff < 0 ? '-' : '';
  const diffTime = Math.abs(diff);
  let days = diffTime / (24 * 60 * 60 * 1000);
  let hours = (days % 1) * 24;
  let minutes = (hours % 1) * 60;
  let seconds = (minutes % 1) * 60;
  [days, hours, minutes, seconds] = [
    Math.floor(days),
    Math.floor(hours),
    Math.floor(minutes),
    Math.floor(seconds)
  ];

  let temp = sign;
  if (days !== 0) {
    temp += days + 'd ';
  }
  if (hours !== 0) {
    temp += hours + 'h ';
  }
  if (minutes !== 0) {
    temp += minutes + 'm ';
  }
  temp += seconds + 's';

  if (onlyLargest) {
    const parts = temp.split(' ');
    if (parts.length > 0) {
      temp = parts[0];
    }
  }

  return temp;
}

export function getRelativeTimeDifference(
  time: Date,
  now: Date
): string | undefined {
  const seconds = Math.floor((time.getTime() - now.getTime()) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return undefined;
    // return `${days}d ${hours % 24}h`;
  } else if (hours > 0) {
    return undefined;
    // return minutes % 60 > 0 ? `${hours}h ${minutes % 60}m` : `${hours}h`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  } else {
    // could be way past due
    if (seconds < -60) {
      return undefined;
    }
    return `${seconds}s`;
  }
}

export function formatDateString(time: Date | string | undefined | null) {
  if (!time) return null;
  if (typeof time === 'string') {
    time = new Date(time);
  }
  return time.toDateString();
}

export function formatTime(
  time: Date | undefined | null,
  includeSeconds = false
) {
  // Format into format HH:mm
  if (!time) return null;

  // check if time is a string
  if (typeof time === 'string') {
    time = new Date(time);
  }

  const hour = time.getHours();
  const minute = time.getMinutes();
  const second = time.getSeconds();
  let temp = hour.toString();
  if (hour == 0) temp = '00';
  temp += (minute < 10 ? ':0' : ':') + minute;
  if (includeSeconds) {
    temp += (second < 10 ? ':0' : ':') + second;
  }

  return temp;
}
